import type { TFunction } from 'i18next';
import { SideSectionTab, WorkUnitsSortOption } from './side-section.type';

/**
 * Build the side-section tab list against the caller's translation function
 * so org-level text_config overrides apply.
 *
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns Tab definitions for the measure-comparison side section
 */
const getTabs = (t: TFunction) => [
  {
    id: SideSectionTab.Details,
    label: t('process_analysis.side_section.details'),
    icon: 'summarize',
  },
  {
    id: SideSectionTab.WorkUnits,
    label: t('process_analysis.side_section.work_units'),
    icon: 'format_list_bulleted',
  },
];

/**
 * Build the work-unit sort options against the caller's translation function
 * so org-level text_config overrides apply.
 *
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns Sort options for the work-units list inside the side section
 */
const getSortOptions = (t: TFunction) => [
  { value: WorkUnitsSortOption.CreatedDate, label: t('process_analysis.work_units.created_date') },
  { value: WorkUnitsSortOption.Type, label: t('process_analysis.work_units.type') },
  {
    value: WorkUnitsSortOption.Points,
    label: t('process_analysis.work_units.points', { estimation: t('common.estimation') }),
  },
];

export { getSortOptions, getTabs };
